(() => {
  const projectId = document.currentScript?.dataset.clarityProjectId;
  if (!projectId || window.nmnClarityScheduled) return;

  window.nmnClarityScheduled = true;
  // Keep the supplied Clarity queue available before its remote script loads.
  window.clarity = window.clarity || function () {
    (window.clarity.q = window.clarity.q || []).push(arguments);
  };

  const loadClarity = () => {
    if (document.querySelector(`script[src*="clarity.ms/tag/${projectId}"]`)) return;

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.clarity.ms/tag/${encodeURIComponent(projectId)}`;
    document.head.append(script);
  };

  const scheduleClarity = () => {
    // Defer Clarity's network and execution work until after the initial page load.
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(loadClarity, { timeout: 2000 });
    } else {
      window.setTimeout(loadClarity, 1500);
    }
  };

  if (document.readyState === "complete") {
    scheduleClarity();
  } else {
    window.addEventListener("load", scheduleClarity, { once: true });
  }
})();
